var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.preloader ? [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "display-flex flex-column justify-content-center align-items-center gap-20"
  }, [_c('div', {
    staticClass: "display-flex justify-content-center align-items-center",
    attrs: {
      "data-testid": "forgot-password-image"
    }
  }, [_c('nuxt-img', {
    staticClass: "w-auto",
    attrs: {
      "src": "/assets/images/svg/ic_forgot-reset-password.svg",
      "alt": "Airalo",
      "height": `125px`,
      "width": `125px`,
      "loading": "lazy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-content-center"
  }, [_c('p', {
    staticClass: "typo-p color-text-secondary text-center mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('scenes.verify.reset.password.description')) + "\n      ")])]), _vm._v(" "), _c('form', {
    staticClass: "w-100",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "display-flex flex-column jusify-content-center align-items-center gap-35"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "general-input"
  }, [_c('div', {
    class: [`field field-text`, {
      'field-invalid': _vm.errors.has('email'),
      'field-filled': _vm.emailForReset.length
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.emailForReset,
      expression: "emailForReset"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: 'required|email',
      expression: "'required|email'"
    }],
    class: ['input', {
      invalid: _vm.errors.has('email'),
      empty: _vm.emailForReset.length <= 0
    }],
    attrs: {
      "id": "email",
      "type": "text",
      "name": "email",
      "data-vv-validate-on": "blur",
      "data-testid": "email-input",
      "data-vv-as": _vm.$t('placeholders.text.field.email'),
      "autocomplete": "on"
    },
    domProps: {
      "value": _vm.emailForReset
    },
    on: {
      "focus": function ($event) {
        return _vm.$validator.errors.remove('email');
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.emailForReset = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('placeholders.text.field.email')) + "\n              ")])]), _vm._v(" "), _vm.errors.first('email') ? _c('div', {
    staticClass: "field-error"
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.errors.first('email')) + "\n              ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 mt-5"
  }, [_c('button', {
    staticClass: "button button-secondary block btn-primary-hv",
    attrs: {
      "disabled": _vm.preloader,
      "data-testid": "continue-button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.validate();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('global.continue')) + "\n          ")])])])])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }